var map = {
	"./avatar_die.mp3": 6107,
	"./boost_off.mp3": 6914,
	"./boost_on.mp3": 4228,
	"./booster_claim.mp3": 9160,
	"./booster_fade_no_collect.mp3": 2443,
	"./end_screen.mp3": 8197,
	"./go.mp3": 853,
	"./heart_claim.mp3": 6320,
	"./jump_version1.mp3": 8951,
	"./jump_version2.mp3": 8880,
	"./jump_version3.mp3": 5973,
	"./laser_blast.mp3": 1971,
	"./laser_shoot.mp3": 4668,
	"./scores1.mp3": 9991,
	"./scores2.mp3": 5056,
	"./scores3.mp3": 1189,
	"./scores4.mp3": 9406,
	"./shield_idle_loop.mp3": 134,
	"./shield_in.mp3": 4538,
	"./shield_out.mp3": 2817,
	"./spikes_slide_in.mp3": 2514,
	"./splash.mp3": 4930,
	"./ui_general_b.mp3": 9999,
	"./wall_impact_version1.mp3": 7978,
	"./wall_impact_version2.mp3": 9709,
	"./wall_impact_version3.mp3": 9720
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7571;